import React from "react";

const AEDSymbol = ({ height, width, fillColor }) => {
  return (
    <svg
      width={width ? width : 29}
      height={height ? height : 33}
      viewBox="0 0 29 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        transform="translate(0.000000,307.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M330 3055 c0 -2 13 -24 30 -47 41 -59 77 -169 95 -290 12 -79 15
             -176 13 -413 l-3 -310 -167 2 c-144 1 -171 4 -205 22 -22 11 -45 27 -52 35
             -27 32 -34 17 -28 -59 9 -127 71 -231 165 -275 38 -19 70 -24 170 -28 l122 -5
             0 -148 0 -149 -172 0 c-186 0 -200 3 -267 64 l-24 21 6 -84 c9 -138 65 -229
             177 -286 26 -14 67 -19 158 -23 l122 -5 0 -326 c0 -344 -9 -441 -49 -555 -21
             -60 -64 -141 -81 -151 -6 -3 -10 -10 -10 -16 0 -13 1184 -12 1330 1 199 18
             412 65 545 120 325 134 563 353 699 645 16 33 44 110 64 170 19 61 40 114 46
             118 17 13 374 -3 410 -18 17 -7 40 -23 50 -34 33 -36 39 -26 33 53 -10 142
             -82 249 -193 289 -35 12 -79 17 -156 17 l-108 0 0 150 0 150 165 0 c147 0 170
             -2 210 -21 24 -11 49 -27 56 -35 25 -30 32 -14 26 62 -8 108 -49 190 -124 246
             l-56 42 -159 8 c-88 4 -161 8 -163 10 -2 2 -20 52 -39 112 -71 213 -161 361
             -311 512 -242 243 -546 375 -965 419 -101 11 -289 15 -747 15 -337 0 -613 -2
             -613 -5z m1385 -174 c112 -27 192 -54 258 -88 246 -124 403 -339 487 -665 11
             -42 20 -88 20 -102 l0 -26 -780 0 -780 0 0 456 0 456 353 -4 c317 -5 361 -7
             442 -27z m805 -1341 l0 -150 -800 0 -800 0 0 150 0 150 800 0 800 0 0 -150z
             m-40 -476 c0 -14 -9 -60 -20 -102 -109 -425 -347 -664 -755 -757 -115 -26
             -135 -28 -452 -32 l-333 -5 0 456 0 456 748 3 c411 1 762 3 780 5 28 2 32 -1
             32 -24z"
          className={fillColor ? fillColor : "fill-text-primary"}
        />
      </g>
    </svg>
  );
};

export default AEDSymbol;
